const provisioning = {
  root: "approvisionnement",
  root_plural: "approvisionnements",
};
export default provisioning;
